import { combineReducers } from '@reduxjs/toolkit';
import formReducer from './form/slice/formSlice';

const proyectoReducer = combineReducers({
  form: formReducer,
});

export default proyectoReducer;
